import React, { useRef } from 'react';
import {
  Icon,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger, Portal, useDisclosure
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

function SimpleTextPopover({ icon, message, onClick }) {
  const focusRef = useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Popover
      cursor="pointer"
      initialFocusRef={focusRef}
      isOpen={isOpen}
      placement="bottom-end"
      trigger="hover"
      onClose={onClose}
      onOpen={onOpen}
    >
      <PopoverTrigger hover variant="unstyled">
        <IconButton colorScheme="black" icon={<Icon as={icon} width={10} />} variant="transparent" onClick={onClick} />
      </PopoverTrigger>
      <Portal>
        <PopoverContent bg="greyScale.200" border="none"><PopoverBody>{message}</PopoverBody></PopoverContent>
      </Portal>
    </Popover>
  );
}

SimpleTextPopover.propTypes = {
  icon: PropTypes.func,
  message: PropTypes.string,
  onClick: PropTypes.func
};

export default SimpleTextPopover;
